import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import Companies from "@/pages/Companies";
import Payments from "@/pages/Payments";
import Invoices from "@/pages/Invoices";
import IncomeExpense from "@/pages/IncomeExpense";
import BankAccounts from "@/pages/BankAccounts";
import Reports from "@/pages/Reports";
import BulkMail from "@/pages/BulkMail";
import Statement from "@/pages/Statement";
import MailSettings from "@/pages/MailSettings";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen grid place-items-center bg-[#090D14] text-slate-500">
        Yükleniyor...
      </div>
    );
  }
  if (user === false) return <Navigate to="/login" replace />;
  return <Layout>{children}</Layout>;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/" element={<Protected><Dashboard /></Protected>} />
            <Route path="/companies" element={<Protected><Companies /></Protected>} />
            <Route path="/payments" element={<Protected><Payments /></Protected>} />
            <Route path="/invoices" element={<Protected><Invoices /></Protected>} />
            <Route path="/income-expense" element={<Protected><IncomeExpense /></Protected>} />
            <Route path="/banks" element={<Protected><BankAccounts /></Protected>} />
            <Route path="/reports" element={<Protected><Reports /></Protected>} />
            <Route path="/bulk-mail" element={<Protected><BulkMail /></Protected>} />
            <Route path="/settings/mail" element={<Protected><MailSettings /></Protected>} />
            <Route path="/companies/:id/statement" element={<Protected><Statement /></Protected>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Toaster theme="dark" position="top-right" richColors closeButton />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
